<template>
    <div class="c-sidebar-tiny">
        <div class="c-sidebar-tiny__inner">
            <ul>
                <router-link to="/setting" v-slot="{href, isActive}">
                    <li :class="[isActive ? 'active' : '']"><a :href="href"><i class="icon24-setting-primary"></i>{{$t('setting')}}</a></li>
                </router-link>
                <router-link to="/billing" v-slot="{href, isActive}" v-if="$store.state.user.permissions.includes('billingSetup')">
                    <li :class="[isActive ? 'active' : '']"><a :href="href"><i class="icon24-bill-primary"></i>{{$t('billing')}}</a></li>
                </router-link>
<!--                <router-link to="/help" v-slot="{href, isActive}">-->
<!--                    <li :class="[isActive ? 'active' : '']"><a :href="href"><i class="icon24-support-primary"></i>{{$t('help')}}</a></li>-->
<!--                </router-link>-->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>